import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, PerformanceType } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class CheckListItem extends BaseExtension {
  get schema(): NodeSpec {
    return {
      content: 'paragraph',
      group: 'block',
      isolating: true,
      parseDOM: [],
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;

  get performanceType(): PerformanceType {
    return PerformanceType.BLOCK_BASED;
  }
}
